/** Preserve small slider values without exposing pointer arithmetic noise. */
export function formatSliderNumber(value: number, min = 0, max = 100, step = 0): string {
    if (!Number.isFinite(value)) return String(value);
    const resolution = step > 0 ? step : Math.abs(max - min) / 1000;
    // Magnitude alone loses fractional step digits: .0025 needs four places,
    // not ceil(-log10(.0025)) == three. Account for scientific notation too.
    const [coefficient, exponent = '0'] = resolution.toString().toLowerCase().split('e');
    const stepPlaces = (coefficient.split('.')[1]?.length ?? 0) - Number(exponent);
    const places = step > 0 ? stepPlaces : Math.ceil(-Math.log10(resolution));
    const decimals = resolution > 0 ? Math.min(6, Math.max(1, places)) : 1;
    const text = value.toFixed(decimals);
    if (value !== 0 && Number(text) === 0) return value.toExponential(2);
    return decimals > 1 ? text.replace(/(\.\d*?[1-9])0+$|\.0+$/, '$1') : text;
}
